import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {Button, Table} from "react-materialize";
import TBSelect from "../Components/Commons/TBSelect.react";
import TBDateRangePicker from "../Components/Commons/Dates/TBDateRangePicker.react";
import {StyledForeground} from "../Components/Commons/StyledForeground.react";
import ExportButton from "../Components/Commons/Buttons/ExportButton.react";
import Pagination from "../Components/Commons/Pagination.react";
import {dateFormatter} from "../Utilities/utilities";

const StyledChartAccountsPage = styled.div`
  padding: 3rem 3rem 8rem 3rem;
  
  h1 {
    color: white;
  }
  
  .filter-selection {
    margin-top: 3rem;
    height: 13rem;
    border: 1px solid white;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .btn {
      color: #484848;
      border: 1px solid #dbdbdb;
      background-color: transparent;
      height: 4rem;
    }
    
    .update-btn {
      margin-left: 1rem;
      background-color: #0288BD;
      color: white;
      border: none;
      
      :hover {
        background-color: #2599C5;
      }
    }
    
    .tb-date-range-picker {
      margin-left: 1rem;
    }
  }
  
  .subheader {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 2.4rem;
    margin-top: 6rem;
    padding-bottom: 2rem;
    color: black;
    
    h3 {
      margin: 0;
      font-weight: bold;
    }
    
    p {
      font-size: 2.4rem;
    }
  }
  
  .tb-export-btn {
    float: right;
  }
  
  .content-container {
    border: 1px solid #E4E6E7;
    margin-bottom: 1rem;
    
    td, th {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    
    th {
      text-align: center;
    }
    
    td {
      text-align: right;
    }
  }
  
  .opening-balance {
    border-bottom: 1px solid black;
    border-top: 1px solid black;
  }
  
  .total-row {
     border-top: 1px solid black;
     border-bottom: 2px solid #E4E6E7;
  }
  
  .closing-balance {
    border-bottom: 1px solid black;
  }
`

const fakeAPIResponse = [{name: '12080 - Fireblocks', id: '1'}, {name: '23500 - Collateral Due to Counterparty', id: '2'}, {name: '10625 - Silvergate Lending LLC - SEN *4109', id: '2'}, {name: '10625 - Silvergate INC - SEN *4191', id: '1'}]


const ChartAccountsPage = () => {
  const [tableData, setTableData] = useState(fakeDataCharts);
  const [accounts, setAccounts] = useState([]);
  const [pageTotal, setPageTotal] = useState(1);
  const [page, setPage] = useState(1);
  const [paginationCount, setPaginationCount] = useState({start: 1, end: 23});

  const [account, setAccount] = useState(false);
  const [date, setDate] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedDate, setSelectedDate] = useState({startDate: '', endDate: ''});

  const [openingBalance, setOpeningBalance] = useState('3,460.79');
  const [closingBalance, setClosingBalance] = useState({debit: '5,337,581.00', credit: '76,544,589'});
  const [total, setTotal] = useState('71,207,007');

  useEffect(() => {
    setAccounts(fakeAPIResponse);
    setDate({startDate: "2021-01-01T18:00:00.000Z", endDate: "2021-06-01T18:00:00.000Z"})
    setAccount({name: '12080 - Fireblocks', id: '1'})
  }, [])

  const handleSelect = (item) => {
    setSelectedAccount(item);
  }

  const handlePagination = (action) => {
    console.log('action =>', action);
  }

  const handleGenerate = () => {
    if (selectedAccount?.id === '1') {
      setTableData(fakeDataCharts);
      setTotal('71,207,007');
      setClosingBalance({debit: '5,337,581.00', credit: '76,544,589'});
      setOpeningBalance('71,207,007');
      const transactionCount = fakeDataCharts.length;
      setPaginationCount({start: transactionCount, end: transactionCount})
      setPage(1);
      setPageTotal(1);
      setDate(selectedDate);
      setAccount(selectedAccount);
    } else if (selectedAccount?.id === '2') {
      setTableData(fakeDataChartsTwo);
      setTotal('12,344,731');
      setClosingBalance({debit: '30,324,406', credit: '5,000,000'});
      setOpeningBalance('13,460.79');
      const transactionCount = fakeDataChartsTwo.length;
      setPaginationCount({start: transactionCount, end: transactionCount})
      setPage(1);
      setPageTotal(1);
      setDate(selectedDate);
      setAccount(selectedAccount);
    } else {
      setPaginationCount({start: 0, end: 0})
      setPageTotal(0);
      setPage(0);
      setAccount(false);
      setDate(selectedDate);
      setAccount(selectedAccount);
    }
  }

  const handleDateSelection = (date) => {
    setSelectedDate(date);
  }

  return (
    <StyledChartAccountsPage>
      <StyledForeground />
      <h1>Accounting</h1>
      <div className={'filter-selection'}>
        <div><TBSelect label={'Account Selection'} handleSelect={handleSelect} listItems={fakeAPIResponse} /></div>
        <div><TBDateRangePicker setDateFilter={handleDateSelection} /></div>
        <div><Button onClick={handleGenerate} className={'update-btn'}>Generate</Button></div>
      </div>
      {
        account == false ?
          <div className={'subheader'}>
            <p>BlockFi</p>
            <p>Please select an account to generate a report</p>
          </div> :
          <div className={'subheader'}>
            <h3>{account?.name} Transactions</h3>
            <p>BlockFi</p>
            {date && <p>{dateFormatter(date.startDate)} - {dateFormatter(date.endDate)}</p>}
          </div>
      }
      <div>
        <ExportButton />
      </div>
      <div className={'content-container'}>
        <Table striped>
          <thead>
            <tr>
              <th data-field='date'>
                Date
              </th>
              <th data-field='type'>
                Type
              </th>
              <th data-field='customer'>
                Counter Party
              </th>
              <th data-field='debit'>
                Debit
              </th>
              <th data-field='credit'>
                Credit
              </th>
              <th data-field='asset'>
                Asset
              </th>
              <th data-field='asset-credit'>
                Asset Debit
              </th>
              <th data-field='asset-debit'>
                Asset Credit
              </th>
            </tr>
          </thead>
          <tbody>
          { account ?
            <>
              <tr className={'opening-balance'}>
                <td>1/1/21</td>
                <td>Opening Balance</td>
                <td></td>
                <td>{closingBalance.debit}</td>
                <td>{openingBalance}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              {tableData.map((entry) => {
                const {date, type, counterParty, debit, credit, asset, assetDebit, assetCredit} = entry;
                return (
                  <tr>
                    <td>{date}</td>
                    <td>{type}</td>
                    <td>{counterParty}</td>
                    <td>{debit}</td>
                    <td>{credit}</td>
                    <td>{asset}</td>
                    <td>{assetDebit}</td>
                    <td>{assetCredit}</td>
                  </tr>
                )
              })}
              <tr className={'total-row'}>
                <td>Total</td>
                <td/>
                <td/>
                <td>{total}</td>
                <td>15,999.89</td>
                <td/>
                <td/>
                <td/>
              </tr>
              <tr className={'closing-balance'}>
                <td>6/30/21</td>
                <td>Closing Balance</td>
                <td/>
                <td>{closingBalance.debit}</td>
                <td>{closingBalance.credit}</td>
                <td/>
                <td/>
                <td/>
              </tr>
            </> :
            <tr>
              <td>No data to display</td>
              <td/>
              <td/>
              <td/>
              <td/>
              <td/>
              <td/>
              <td/>
            </tr>
          }
          </tbody>
        </Table>
      </div>
      <Pagination
        handleClick={handlePagination}
        label={'Transactions'}
        total={tableData.length}
        page={page}
        count={paginationCount}
        pages={pageTotal}
        perPage={'50'}
      />
    </StyledChartAccountsPage>
  )
}

export default ChartAccountsPage;

const fakeDataCharts = [
  {date: '1/29/21', type: 'MARGIN - INITIAL', counterParty: '03b02163-e7a9-4a83-ae7d-c02ee5f46a7a', debit: '2,404,247.93', credit: '', asset: 'BTC', assetDebit: '65.00000000', assetCredit: ''},
  {date: '2/13/21', type: 'MARGIN - CALL', counterParty: 'eb60a2c1-4078-4cfd-809e-8f7f4bc368fd ', debit: '', credit: '3,000.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '2/14/21', type: 'LOAN - LENDER', counterParty: '712bac45-7333-4ecd-964e-5c750bdce9ac', debit: '1,302,000.01', credit: '', asset: 'BTC', assetDebit: '', assetCredit: '982.00230000'},
  {date: '2/16/21', type: 'MARGIN - CALL', counterParty: '8579a88f-be4b-402f-bce3-96dc32fbdab9 ', debit: '32,928.50387', credit: '', asset: 'BTC', assetDebit: '0.97050000', assetCredit: ''},
  {date: '2/20/21', type: 'MARGIN - SETTLEMENT', counterParty: '7c2aea4b-250e-44cc-8033-4232ebc54975', debit: '3,203.03', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '2/13/21', type: 'LOAN - LENDER', counterParty: '7cf48be7-4059-4ab7-b446-1910ff333872', debit: '279,032.88', credit: '', asset: 'ETH', assetDebit: '', assetCredit: '100.00000000'},
  {date: '3/22/21', type: 'LOAN - BORROWER', counterParty: 'b53c475f-8f70-4804-9a13-276912a44dbd', debit: '', credit: '13.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '3/13/21', type: 'MARGIN - INITIAL', counterParty: '01b02163-e7a9-4a83-ae7d-c02ee5f46a4a', debit: '', credit: '3,000.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '3/13/21', type: 'MARGIN - CALL', counterParty: 'cb02163-e7a9-4a83-ae7d-c02ee5f46a7a', debit: '3,270.76', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '3/13/21', type: 'MARRGIN - SETTLEMENT', counterParty: '3b0163-e7a9-4a83-ae7d-c02ee', debit: '', credit: '9,032.88', asset: 'BTC', assetDebit: '0.4500000012', assetCredit: ''},
  {date: '4/13/21', type: 'LOAN - LENDER', counterParty: 'e152ffda-373b-4abb-a262-363dbebd3e00', debit: '', credit: '13', asset: '', assetDebit: '', assetCredit: ''},
  {date: '4/13/21', type: 'LOAN - BORROWER', counterParty: '0b2163-e7a9-4a83-ae7d-c02ee5f4', debit: '', credit: '128.58', asset: '', assetDebit: '', assetCredit: ''},
  {date: '4/13/21', type: 'LOAN - BORROWER', counterParty: 'b0163-e7a9-4a83-ae7d-c02ee5f46a', debit: '', credit: '348.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'MARGIN - RELEASE', counterParty: '904d0b01-83bf-4ff1-b9b7-4c36324ae2ca', debit: '', credit: '3,000.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'LOAN - LENDER', counterParty: 'c166abcb-deab-491a-81c0-7f4b53688437', debit: '', credit: '8.28', asset: 'BTC', assetDebit: '', assetCredit: '2.00234063'},
  {date: '5/13/21', type: 'LOAN - BORROWER', counterParty: '2163-e7a9-4a83-ae7d-c02ee5f46a', debit: '', credit: '179.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'MARGIN - CALL', counterParty: 'b02163-e7a9-4a83-ae7d-c02ee5f46a6a', debit: '', credit: '13.93', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'LOAN - LENDER', counterParty: 'e301b956-ff04-47b5-aa39-7b0625d3a11d', debit: '3,018.14', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'LOAN - BORROWER', counterParty: 'b02163-e7a9-4a83-ae7d-c02ee5f46a45', debit: '', credit: '3,000.00', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'MARGIN - INITIAL', counterParty: '73a6887d-548f-4fd9-ada2-f7b278ae855f', debit: '3,677.79', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'MARGIN - CALL', counterParty: '91a54d4e-72f0-4892-a012-f481dc24446f', debit: '3,000.00', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'MARGIN - RELEASE', counterParty: 'a8ab1d78-f739-4231-809a-51f493f93c3b', debit: '', credit: '10.20', asset: '', assetDebit: '', assetCredit: ''},
  {date: '5/13/21', type: 'MARGIN - CALL', counterParty: 'f79f0579-ac12-467a-8a5a-f9c5199fa684', debit: '10.20', credit: '', asset: '', assetDebit: '', assetCredit: ''},
]

const fakeDataChartsTwo = [
  {date: '1/29/21', type: 'LOAN - BORROWER', counterParty: 'e6e50078-b58a-4b93-9b48-8aca8b4d701e', debit: '1,092,000.00', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '2/13/21', type: 'LOAN - BORROWER', counterParty: 'b5829732-79ff-48ab-85ef-b8b8411b4302 ', debit: '10,000,000.00', credit: '', asset: '', assetDebit: '', assetCredit: ''},
  {date: '2/14/21', type: 'LOAN - LENDER', counterParty: 'c166abcb-deab-491a-81c0-7f4b53688437', debit: '', credit: '11,092,000.00', asset: '', assetDebit: '', assetCredit: '982.00000000'},
]